import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthNavigationHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isInitialized } = useAuth();

  useEffect(() => {
    // Listen for auth messages from other tabs
    if (window.BroadcastChannel) {
      const channel = new BroadcastChannel('auth-channel');

      channel.onmessage = (event) => {
        if (event.data.type === 'LOGOUT') {
          console.log('Received logout message from another tab');
          ['authToken', 'tokenTimestamp', 'userId', 'userName', 'userEmail',
            'userCreatedAt', 'userLastLogin', 'companyId', 'companyName'].forEach(
            key => localStorage.removeItem(key)
          );
          navigate('/');
        }
      };

      return () => channel.close();
    }
  }, [navigate]);

  useEffect(() => {
    // Only handle navigation after auth is initialized
    if (!isInitialized) return;

    const publicPaths = [
      '/alterar-senha',
      '/nova-senha',
      '/finalizar-cadastro',
      '/planos',
      '/cadastro-finalizado'
    ];

    if (!user && !publicPaths.includes(location.pathname)) {
      console.log('User signed out, redirecting to home');
      navigate('/');
    }
  }, [user, isInitialized, location.pathname, navigate]);

  return null; // This component doesn't render anything
};

export default AuthNavigationHandler;
